import {
  LinearProgress,
  Button,
  useMediaQuery,
} from "@mui/material";
import Box from "@mui/material/Box";
import { useTheme } from "@emotion/react";
import { DataGrid, GridToolbarContainer } from "@mui/x-data-grid";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as XLSX from "xlsx";
import { Orders, setOrderPinsDialog } from "../../../../../app/slices/orderSlice";
import { ExportButton } from "../../../../../components/ExportExcel/ExportButton";
import { HiOutlineQrCode, HiOutlineArrowDownTray } from "react-icons/hi2";
import FormDialog, { PlainCard } from "../../../../../components/FormDialog";
import { BRAND } from "../../../../../components/MobileList";
import {
  MobileEmpty,
  MobileListItem,
  MobileListShell,
} from "../../../../../components/MobileList";

const OrderPinsTabel = (props) => {
  const dispatch = useDispatch();

  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const loading = useSelector((state) => state.orders.order.loading);
  const _pinsOrder = useSelector((state) => state.orders.pinsOrder);

  const pinsColumns = [
    {
      field: "sequence",
      headerName: "#",
      flex: 0.4,
    },
    {
      field: "serial_number",
      headerName: "الرقم التسلسلي",
      flex: 1,
    },
    {
      field: "pin_number",
      headerName: "الرقم السري",
      flex: 1,
    },
    {
      field: "expiry_date",
      headerName: "تاريخ النفاذ",
      flex: 1,
    },
  ];

  useEffect(() => {
    if (_pinsOrder.dialog && _pinsOrder.order_id) {
      dispatch(Orders.getPinsOrder(_pinsOrder.order_id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_pinsOrder.order_id]);

  const customToolbar = () => (
    <GridToolbarContainer {...props}>
      <ExportButton
        fileName={_pinsOrder.order_id + " - " + _pinsOrder.data[0]?.item_name}
      />
    </GridToolbarContainer>
  );

  // The grid toolbar's export reads from the DataGrid api, which isn't mounted
  // on mobile, so the card list exports straight from the loaded rows.
  const handleMobileExport = () => {
    const rows = (_pinsOrder.data ?? []).map((pin, index) => ({
      sequence: index + 1,
      serial_number: pin.serial_number,
      pin_number: pin.pin_number,
      expiry_date: pin.expiry_date,
    }));

    const worksheet = XLSX.utils.json_to_sheet(rows);
    XLSX.utils.sheet_add_aoa(
      worksheet,
      [["#", "الرقم التسلسلي", "الرقم السري", "تاريخ النفاذ"]],
      { origin: "A1" }
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet);
    XLSX.writeFile(
      workbook,
      `${_pinsOrder.order_id} - ${_pinsOrder.data?.[0]?.item_name ?? ""}.xlsx`,
      { compression: true }
    );
  };

  return (
    <FormDialog
      open={_pinsOrder.dialog}
      onClose={() => dispatch(setOrderPinsDialog(null))}
      icon={<HiOutlineQrCode />}
      title="تفاصيل الفاتورة"
      subtitle={
        _pinsOrder.order_id
          ? `فاتورة رقم ${_pinsOrder.order_id}${
              _pinsOrder.data?.[0]?.item_name
                ? ` - ${_pinsOrder.data[0].item_name}`
                : ""
            }`
          : undefined
      }
      maxWidth="md"
    >
      {!_pinsOrder.data ? (
        <PlainCard>
          <LinearProgress />
        </PlainCard>
      ) : smallScreen ? (
        <MobileListShell loading={loading}>
          <PlainCard sx={{ p: 1 }}>
            <Button
              fullWidth
              size="small"
              startIcon={<HiOutlineArrowDownTray />}
              onClick={handleMobileExport}
              disabled={!_pinsOrder.data?.length}
              sx={{ color: BRAND, fontWeight: 700 }}
            >
              تحميل Excel
            </Button>
          </PlainCard>
          {_pinsOrder.data.length > 0 ? (
            _pinsOrder.data.map((pin, index) => (
              <MobileListItem
                key={index}
                avatar={index + 1}
                title={`الرقم التسلسلي ${pin?.serial_number ?? "-"}`}
                subtitle={
                  pin?.expiry_date ? `تاريخ النفاذ: ${pin.expiry_date}` : undefined
                }
                fields={[
                  {
                    label: "الرقم السري",
                    value: pin?.pin_number,
                    span: 12,
                  },
                ]}
              />
            ))
          ) : (
            <MobileEmpty />
          )}
        </MobileListShell>
      ) : (
        <PlainCard>
          <Box>
            <DataGrid
              rows={_pinsOrder.data?.map((data, index) => {
                return { ...data, sequence: index + 1 };
              })}
              columns={pinsColumns}
              autoHeight
              rowCount={_pinsOrder.total}
              loading={loading}
              rowHeight={30}
              components={{
                LoadingOverlay: LinearProgress,
                Toolbar: customToolbar,
              }}
              sx={{ border: "none" }}
            />
          </Box>
        </PlainCard>
      )}
    </FormDialog>
  );
};

export default OrderPinsTabel;
